export default __webpack_public_path__ + "static/media/ic_matic_24.03c3d5ff.svg";